<template>
  <el-menu-item :index="menu.fullPath || `${basePath}/${menu.path}`">
    <i :class="menu.icon" v-if="menu.icon"></i>
    <span slot="title">{{ menu.title || menu.meta.title }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'SidebarMenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
</style>